import React, { useEffect, useState } from "react";
import { ActionsCreators } from "../../../actions";
import { actionCreators as contentActions } from "../../../actions/contents/carousel.actions";
import Area from "../../../aGlobalDesign/Area/Area";
import strings from "../../../helpers/Localization";
import Pill from "../../../aGlobalDesign/Pill/Pill";
import CardAd from "../../../components/Carousel/CardAd";
import { useDispatch } from "react-redux";
import Loader from "../../../aGlobalDesign/Loader/Loader";

const CarouselCommitment = () => {

    const [carousel, setCarousel] = useState({
        adActivated: null,
        transition: null, // "fade" or "slide"
        displayTimeInSeconds: 5,
        adList: []
    });
    const [adsList, setAdsList] = useState([]);
    const [reportingCarousel, setReportingCarousel] = useState({
        ads: [],
        totalView: 0,
        totalClick: 0
    });
    const [allTotalViews, setAllTotalViews] = useState(0);
    const [allTotalClicks, setAllTotalClicks] = useState(0);
    const [isLoadingCarousel, setIsLoadingCarousel] = useState(true);
    const [isLoadingReporting, setIsLoadingReporting] = useState(true);


    const dispatch = useDispatch();
    const changeAppBarTitle = (payload) => dispatch(ActionsCreators.changeAppBarTitle(payload));
    const ChangeCurrentMenuName = (payload) => dispatch(ActionsCreators.ChangeCurrentMenuName(payload));



    useEffect(() => {
        changeAppBarTitle(strings.Commitment);
        ChangeCurrentMenuName("Commitment");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const getCarousel = () => {
        setIsLoadingCarousel(true);

        dispatch(
            contentActions.GetCarousel(
                (data) => {
                    const safeData = data ? data : initialCarouselState;
                    setCarousel(safeData);
                    setAdsList(safeData.adList);
                    setIsLoadingCarousel(false);
                },
                (error) => {
                    console.error("Error GetCarousel :", error);
                    setIsLoadingCarousel(false);
                }
            )
        );
    };



    const getCarouselReporting = () => {
        setIsLoadingReporting(true);

        dispatch(
            contentActions.GetCarouselReporting(
                (data) => {
                    const safeData = data ? data : { ads: [], totalView: 0, totalClick: 0 };
                    setReportingCarousel(safeData);
                    setAllTotalViews(safeData.totalView);
                    setAllTotalClicks(safeData.totalClick);
                    setIsLoadingReporting(false);
                },
                (error) => {
                    console.error("Error getCarouselReporting :", error);
                    setIsLoadingReporting(false);
                }
            )
        );
    };



    useEffect(() => {
        getCarousel();
        getCarouselReporting();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const reportingById = Object.fromEntries(
        (reportingCarousel ? reportingCarousel.ads : []).map(r => [r.id, r])
    );



    const isLoading = isLoadingCarousel || isLoadingReporting;

    return <>
        <div className='commitment-container'>
            <div className='commitment-header'>
                <div className='card-commitment'>
                    <Pill
                        type="current"
                        onClick={null}
                        text={strings.Impressions}
                    />
                    <div className='card-commitment-number'>{isLoading ? <Loader dimensions="40px" color={"var(--primary-base)"} /> : allTotalViews}</div>
                </div>
                <div className='card-commitment'>
                    <Pill
                        type="current"
                        onClick={null}
                        text={strings.Openings}
                    />
                    <div className='card-commitment-number'>{isLoading ? <Loader dimensions="40px" color={"var(--primary-base)"} /> : allTotalClicks}</div>
                </div>
            </div>
            {
                isLoading ?
                    <div className='commitment-main' style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
                        <Loader dimensions="40px" color={"var(--primary-base)"} />
                    </div>
                    :
                    adsList.length > 0 && <div className='commitment-main'>
                        {[...adsList] // copy for don't mute state
                            .sort((a, b) => a.position - b.position) // sort by position
                            .map((ad) =>
                                <CardAd
                                    key={ad.id}
                                    ad={ad}
                                    reportingAd={reportingById[ad.id]}
                                />
                            )
                        }
                    </div>


            }

        </div>
    </>
    ;
};

export default CarouselCommitment;
